import { render, staticRenderFns } from "./DiscoveryDeleteDialog.vue?vue&type=template&id=119a1d57&"
import script from "./DiscoveryDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./DiscoveryDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports